import { render, staticRenderFns } from "./StepDateAndName.vue?vue&type=template&id=2ac00458&"
import script from "./StepDateAndName.vue?vue&type=script&lang=js&"
export * from "./StepDateAndName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports